import api from "@/services/api.ldapManagement.service";
import { ActionTree } from "vuex";
import { LDAPAddress, LDAPManagementState, LDAPPort } from "./types";
import { RootState } from "@/store/types";

export const actions: ActionTree<LDAPManagementState, RootState> = {
    /**
     * Loads all available LDAP Addresses.
     */
    async loadLDAPAddresses({ commit }) {
        const data = await api.loadLDAPAddresses();
        commit("setAddresses", data);
    },

    /**
    * Deletes an item of LDAPAddress from the DB, and updates the store if the operation
    * is successful.
    */
    async removeLDAPAddress({ commit }, ldapAddressToDelete: LDAPAddress) {
        await api.deleteLDAPAddress({
            address: ldapAddressToDelete.address
        });

        const { address } = ldapAddressToDelete;
        // Once we've deleted the ldapAddress on the server-side, remove it from the store
        commit("removeAddress", address);
    },

    /**
    * Creates new item of LDAPAddress in the DB, and updates the store if the operation
    * is successful.
    */
    async addNewLDAPAddress({ commit }, ldapAddressToCreate: LDAPAddress) {
        await api.addNewLDAPAddress(ldapAddressToCreate);
        commit("addNewLDAPAddress", ldapAddressToCreate);
    },

    /**
     * Update item of LDAPAddress in the DB, and updates the store, if the operation
     * is successful.
     */
    async updateLDAPAddress({ commit }, { previousAddress, newAddress }) {
        const updatedAddress = await api.updateLDAPAddress(previousAddress, newAddress);
        commit("updateLDAPAddress", { previousAddress, updatedAddress });
    },

    /**
    * Load Port for LDAP Services.
    */
    async loadLDAPPort({ commit }) {
        const data = await api.loadLDAPPort();
        if (typeof data.port === "string" && data.port === "") {
            data.port = null;
        }
        commit("setLDAPPort", data);
    },

    /**
      * Update item of LDAPPort in the DB, and updates the store if the operation
      * is successful.
      */
    async updateLDAPPort({ commit }, newPort: LDAPPort) {
        const updatedPort = await api.updateLDAPPort(newPort);
        const validPort = updatedPort;
        if (typeof validPort.port === "string" && validPort.port === "") {
            validPort.port = null;
        }
        commit("updateLDAPPort", validPort);
    }
}
